import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React from "react";
import AppRoutes from "./AppRoutes";
import { useAuthUser } from "../features/auth/authHooks";
import Spinner from "react-bootstrap/esm/Spinner";

function App() {
  const { isLoading, isLoggedIn, hasValidRole, loginUrl, logoutUrl } =
    useAuthUser();

  if (isLoading) {
    return (
      <div
        className="d-flex w-100 justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="d-flex gap-16 align-items-center">
          <Spinner animation="border" /> Kirjaudutaan sisään...
        </div>
      </div>
    );
  }

  if (!isLoading && isLoggedIn && !hasValidRole) {
    return (
      <div
        className="d-flex w-100 justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-xl-5">
              <div className="card shadow">
                <div className="card-body text-center">
                  <h1 className="h4 mb-16 d-flex align-items-center justify-content-center">
                    <span className="text-danger bi bi-exclamation-triangle me-16 fs-1"></span>
                    Pääsy evätty
                  </h1>
                  <p>Sinulla ei ole oikeuksia tähän palveluun.</p>
                  <a href={logoutUrl}>Kokeile kirjautua uudelleen sisään</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isLoading && !isLoggedIn) {
    // console.log("Redirecting to login URL.");
    window.location.href = loginUrl;
    return null;
  }

  // Process pending redirect only after account selection is completed (if required)
  const selectionDone = localStorage.getItem("accountSelectionDone") === "true";
  const redirectAfterLogin = localStorage.getItem("redirectAfterLogin");
  if (selectionDone && redirectAfterLogin != null) {
    window.location.href = redirectAfterLogin;
    localStorage.removeItem("redirectAfterLogin");
  }

  return <RouterProvider router={createBrowserRouter(AppRoutes)} />;
}

export default App;
